import ApplicantList from "@/controllers/applicant/applicant-list.js";

export default {
  extends: ApplicantList,
};
